import { Component, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormResponse } from 'src/models/form-response';
import { AccountService } from 'src/app/services/account.service';
import { AlertBoxType } from '../base/alert-box/alertboxtype';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  public loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(4)]),
    captcha: new FormControl('')
  });

  public formResponse: FormResponse;

  public alertBoxTypes = AlertBoxType;

  public submitDisabled = false;

  constructor(private accountService: AccountService, private changeDetector: ChangeDetectorRef) { }

  get email() { return this.loginForm.get('email'); }

  get password() { return this.loginForm.get('password'); }

  get captcha() { return this.loginForm.get('captcha'); }

  public submit() {
    if (this.loginForm.valid) {
      this.submitDisabled = true;

      this.accountService.login(this.email.value, this.password.value, this.captcha.value).subscribe((result: FormResponse) => {
        this.formResponse = result;

        if (this.formResponse.result === true) {
          this.loginForm.reset();
        }

        this.submitDisabled = false;

        this.changeDetector.detectChanges();
    });
    } else {
      this.email.markAsDirty();
      this.password.markAsDirty();
    }
  }

  public hasErrors() {
    return this.formResponse !== undefined && this.formResponse.errors !== undefined && this.formResponse.errors.length > 0;
  }

}
